import { axiosGet, axiosPost, axiosPut, axiosDelete } from "../options/header"

export default {
  getAll(accessToken,page, br_postupka, faza, broj_predmeta, start_date, end_date, isArchived, isDestroyed, year_filter, id_person,case_type) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti", {
        params: {
          
          page,
          br_postupka, 
          faza,
          broj_predmeta,
          start_date,
          end_date,
          isArchived,
          isDestroyed,
          year_filter,
          id_person,
          case_type
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  searchPredmeti(srch_txt) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/search", {
        params: {
          srch_txt
        },
        

      });
    } catch {
      console.log("Failed attempt at search.");
    }
  },
  getAllOdvjetniciShort() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/odvjetnici", {
        

      });
    } catch {
      console.log("Failed attempt at search.");
    }
  },
  getAllFilteri() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/filteri", {
        params: {},
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllPhases() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/faze", {
        params: {},
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTeam(predmetId) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId+"/team", {
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  
  getUserCasePermissions(predmetId, user_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId+"/permissions", {
        params: {
          user_id : user_id
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTeamShort(predmetId) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId+"/team_short", {
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addTmpTeamMember(predmetId,uid,end_date,access_token ) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId+"/team/"+uid+"/temp", {
        params: {
          end_date,
          access_token
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  editTmpTeamMember(predmetId,uid,end_date ) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId+"/team/"+uid+"/temp", {
        params: {
          end_date,
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
 removeTmpTeamMember(predmetId,uid,access_token ) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId+"/team/"+uid+"/temp", {
        params: {
          access_token
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllTeamShort() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/all_members", {
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllSluzbenaUloga() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sluzbena-uloga", {
        params: {},
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllServiceType() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/service-type", {
        params: {},
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addServiceType(sifra_val) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/service-type", {
        params: {
          sifra_val
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateServiceType(sifra_val, id) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/service-type/"+id, {
        params: {
          sifra_val
        },
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteServiceType(id) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/service-type/"+id, {
        
      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllOznakeStatus() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/oznake-status", {
        params: {},
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addOznakeStatus(sifra_val) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/oznake-status", {
        params: {
          sifra_val
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addSluzbenaUloga(sifra_val) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sluzbena-uloga", {
        params: {
          sifra_val
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllPostupci() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/postupci", {
        params: {},
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllType() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/type", {
        params: {},
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addNewPostupak(sifra_val) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/postupci", {
        params: {
          sifra_val
        },
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  addNewFaza(sifra_val) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/faze", {
        params: {
          sifra_val
        },
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updatePostupak(sifra_val, id) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/postupci/"+id, {
        params: {
          sifra_val
        },
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  deletePostupak(id) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/postupci/"+id, {
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateOrderSifre(sifra_val, id) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sifre-order/"+id, {
        params: {
          sifra_val
        },
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateFaze(sifra_val, id) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/faze/"+id, {
        params: {
          sifra_val
        },
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteFaze(id) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/faze/"+id, {
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateOznakeStatus(sifra_val, id) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/oznake-status/"+id, {
        params: {
          sifra_val
        },
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteOznakeStatus(id) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/oznake-status/"+id, {
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateSluzbenaUloga(sifra_val, id) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sluzbena-uloga/"+id, {
        params: {
          sifra_val
        },
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteSluzbenaUloga(id) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sluzbena-uloga/"+id, {
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  getAllBrojevi(accessToken) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/broj_predmeta", {
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },

  getSingle(predmetId, logged_uid) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId, {
        params: {
          logged_uid,
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getSingleCaseQA(predmetId) {
    console.log(predmetId, "predmetId")
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmetId+"/qna", {
        params: {},
      
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateSingleQa( single_qa) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+single_qa.case_id+"/qna/"+single_qa.uid, {
        params: {
          single_qa : single_qa
        },
      
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addPredmet(unos_predmeta, access_token, logged_uid) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/init-case", {
        params: {
          unos_predmeta,
          access_token,
          logged_uid
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  initInhouseCase(stranka) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/inhouse/innit", {
        params: {
          stranka
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updatePredmet(unos_predmeta, access_token,predmet_id, logged_uid) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmet_id, {
        params: {
          unos_predmeta,
          access_token,
          logged_uid
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateOrdering(predmet_id, participant_order) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmet_id+"/participant-order", {
        params: {
          participant_order
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  
  addPredmetGraph(unos_predmeta, access_token, graph_url) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/initialize/graph", {
        params: {
          unos_predmeta,
          access_token,
          graph_url
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  arhivirajPredmet(predmet_id, datum_arhiviranja) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmet_id+"/arhiviraj", {
        params:{
          datum_arhiviranja
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  aktivirajPredmet(predmet_id) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmet_id+"/aktiviraj", {
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  unistiPredmet(predmet_id, datum_unistavanja) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmet_id+"/unisti", {
        params:{
          datum_unistavanja
        }, 
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  saveCaseReport(uid, predmet_id, report, report_date) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+predmet_id+"/save-case-report", {
        params:{
          uid,
          report,
          report_date
        }, 
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  // NAPOMENE START
  addPredmetNapomena(napomena,group_url) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+group_url+"/napomene", {
        params: {
          napomena
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addPredmetNote(note,note_id) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+note_id+"/notes", {
        params: {
          note
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  editPredmetNote(note,group_url) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+group_url+"/notes", {
        params: {
          note
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteNote(id) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/notes/"+id, {
        

      });
        } catch {
      console.log("Failed attempt at group.");
    }
  },
  addNewKal(kal_object, group_url) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+group_url+"/kal", {
        params: {
          kal_object,
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  editKal(kal_object) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/edit/kal", {
        params: {
          kal_object,
        },
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPredmetNapomene(group_url) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+group_url+"/napomene",{
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPredmetNotes(group_url) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+group_url+"/notes",{
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getCaseTasks(group_url) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+group_url+"/tasks",{
        

      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  // NAPOMENE END




};
